<template>
  <li class="link">
    <component
      :is="content.link ? 'a' : 'div'"
      :href="content.link"
      :target="content.link ? '_blank' : null"
      :title="content.link ? content.title : null"
    >
      <h3 class="small-title --arrow">
        <span>{{ content.title }}</span>
        <Icon id="arrow" v-if="content.link" />
      </h3>
      <p>{{ content.description }}</p>
    </component>
  </li>
</template>

<script>
import { Icon } from '@/components/global'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'LinkCard',
  mixins: [DefaultSectionProps],
  components: { Icon },
}
</script>
